// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__e9XqY","anima":"Alert_anima__iGQLf"};